
export const firebaseConfig = {
  // Configuración para el proyecto 'portal-brokers-ciencuadras'.
  apiKey: "AIzaSyDfnFumTT3Ey4UoIJCBgwnPQTEvv-p2gMg",
  authDomain: "portal-brokers-ciencuadras.firebaseapp.com",
  projectId: "portal-brokers-ciencuadras",
  // Se usa el nombre exacto que aparece en tu comando 'gsutil ls'
  storageBucket: "portal-brokers-ciencuadras.firebasestorage.app",
  messagingSenderId: "207524556330",
  appId: "1:207524556330:web:c6e887b74afb359b235d53"
};

// --- Constants & Colors often used with Firebase styling or branding ---
export const CIEN_CUADRAS_BLUE = '#005A9E';
export const CIEN_CUADRAS_BUTTON_BLUE = '#0073b7';
